export * from './Quote';
export * from './ContentfulQuote';
